import React, { ReactElement, Ref, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDropzone } from 'react-dropzone'
import UrlImageDropZone from './UrlImageDropZone';
import { Eye } from '../../assets/svgs';
import TrashBin from '../../assets/svgs/trashBin';
import CreateFileAction from '../operational/createFileAction';
import { UploadImageAsFormData } from '../operational/UploadImageAsFormData'
import { translate } from '../../utils/language';
import { Accept } from 'react-dropzone';

const getAspectRatio = async (type: "video" | "image", url: string): Promise<number> => {
    return new Promise((resolve, reject) => {
        if (type === "video") {
            const video = document.createElement('video');
            video.addEventListener('loadedmetadata', () => {
                const width = video.videoWidth;
                const height = video.videoHeight;
                resolve(width / height);
            });
            video.addEventListener('error', () => reject("Error loading video"));
            video.src = url;
        } else if (type === "image") {
            const img = new Image();
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                resolve(width / height);
            };
            img.onerror = () => reject("Error loading image");
            img.src = url;
        }
    });
};

const MyUploadMediaInput = (props: { obJectFit?: any, text: string, preImage: any, error?: any, imageWidth: any, specialDesc?: any, imageHeight?: any, onChange: any, accept?: Accept, enableVideoUpload?: boolean, backgroundColor: string, type: string, enableFileTypes: true }) => {
    const { obJectFit, preImage, error, onChange, imageHeight, imageWidth, text, specialDesc, accept, enableVideoUpload, backgroundColor, type, enableFileTypes } = props;
    const [selectedFile, setSelectedFile] = useState('');
    const [preview, setPreview] = useState(false);
    const [isError, setIsError] = useState(false);
    const handleFileUpload = async (acceptedFiles: any) => {
        const type = acceptedFiles[0]?.type?.split("/")?.[0]
        const response = await UploadImageAsFormData(acceptedFiles[0])
        //@ts-ignore

        if (!response || response?.error) return setIsError(translate(response?.errorMessage || "imageCouldNotBeUploaded"))
        //@ts-ignore
        const photoUrl = response?.result?.resultData?.url
        const aspectRatio = await getAspectRatio(type, photoUrl)

        setSelectedFile(photoUrl);
        onChange((enableFileTypes || enableVideoUpload) ? { url: photoUrl, type: type, aspectRatio: aspectRatio } : photoUrl);
        setIsError(false);
    };
    const handleClickPreviewIcon = (e: any) => {
        setPreview(true);
    }
    const handleClickDeleteIcon = (e: any) => {
        setSelectedFile('');
        onChange("");
    }

    useEffect(() => {
        setSelectedFile(preImage);
        setIsError(false)
    }, [preImage])
    return (

        <div className='w-[100%] h-full' >
            {preview &&
                <div onClick={(e) => { setPreview(false) }}>
                    <div className='shadow'></div>
                    <div className={` fixed flex flex-wrap justify-center content-center z-[600] top-0 left-0 w-[100%] h-[100%] w-[60%] h-[50%] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] bg-white rounded-2xl`} >
                        {type === "video" ?

                            <video src={selectedFile}

                            ></video>
                            :
                            <img src={selectedFile} className=' w-full h-full self-center' style={{ objectFit: obJectFit || "contain" }} />
                        }

                    </div>
                </div>}
            <div className={`imageEditParent bg-white flex w-[100%]  border-2 border-dashed relative rounded-xl h-full
             overflow-hidden h-[${imageHeight}]  flex-row justify-center ${(isError || error) && !preImage ? "border-red-500" : ""}`}   >
                <style>
                    {`.imageEditParent:hover .imageEdit{
                        display:flex
                    }`}
                </style>
                {selectedFile &&
                    <div className='w-[100%] h-[100%] relative flex justify-center items-center'>

                        <div className="text-center justify-center flex flex-col items-center w-full h-full">
                            {type === "video" ?

                                <video style={{ zIndex: 0, objectFit: obJectFit || "contain" }} src={selectedFile}

                                ></video>
                                :
                                <img src={selectedFile} className=' w-full h-full self-center' style={{ objectFit: obJectFit || "contain" }} />
                            }


                        </div>
                        <div className={`hidden imageEdit absolute top-0 left-0 w-[100%] h-full bg-black bg-opacity-40`}>

                            <div className=' w-[100%] h-full flex flex-col justify-center items-center'>
                                <Eye className="hover:fill-[#6837F8] fill-white w-[15%]" onClick={handleClickPreviewIcon} />
                            </div>
                            <TrashBin className='hover:fill-[#6837F8] fill-white absolute top-0 right-0 p-2 hover:text-blue-500 w-[30px]' onClick={(e: any) => { handleClickDeleteIcon(e) }} />
                        </div>

                    </div>
                }
                <div className={`${selectedFile ? "hidden" : ""} w-full h-full`}>
                    <UrlImageDropZone
                        enableVideoUpload={enableVideoUpload}
                        accept={accept}
                        isError={isError} text={text}
                        onFileUpload={handleFileUpload}
                        width={imageWidth} height={imageHeight}
                        specialDesc={specialDesc}
                    />
                </div>
            </div>


        </div>

    );
};

export default MyUploadMediaInput;
